const { 
    update_button_visibility,
    clear_error,
    render_request_error,
    register_request_error_rederer,
    default_error_rederer,
    disable_next,
    enable_next,
    change_close_button_title
} = require('./page_transition.js');

const {
    input_empty
} = require('./form_check_helper');

const { do_application } = require('./XX_application_contest.js');

const nunjucks = require('nunjucks');

module.exports.page5_once = (application_context)=>{
    let DOM_input_box_credit_number;

    // FIXME:ここで判定してたらおかしい
    if(application_context.page in application_context.ary_run_once){
        return;
    } else {
        application_context.ary_run_once[application_context.page]=true;
        
    }
    
    

    //DOM_input_title_local_language = document.querySelector(`[data-page="4"] [name="title_local_language"]`);
    DOM_input_box_credit_number = document.querySelector(`[data-page="5"] .input_box_credit_number`);
    DOM_radio_payment_method_credit = document.querySelector(`[data-page="5"] [value="credit"]`);
    DOM_radio_payment_method_bank_transfer = document.querySelector(`[data-page="5"] [value="bank_transfer"]`);
    
    if(DOM_radio_payment_method_credit){
        DOM_radio_payment_method_credit.addEventListener('click',(e)=>{
            DOM_input_box_credit_number.classList.remove('hide');
        });
    }
    if(DOM_radio_payment_method_bank_transfer){
        DOM_radio_payment_method_bank_transfer.addEventListener('click',(e)=>{
            DOM_input_box_credit_number.classList.add('hide');
        });
    }
}

module.exports.page5_prev = (application_context)=>{
    let page;

    window.splide_instance.go("<");

    page = window.splide_instance.index;
    application_context.page = page;

    update_button_visibility(application_context);    
}

register_request_error_rederer("request-error-93855a23-9459-4811-9027-f816742aadf5",default_error_rederer);


module.exports.page5_next = async (application_context)=>{

    let blob_response;
    // 次に進むタイミングでベリファイエラーをリセットする。
    application_context.ary_verify_error.length=0;
    clear_error({page:5});
    
    disable_next(application_context);

    blob_response = await do_application(application_context);

    if(blob_response.result == "success"){
        let page;

        window.splide_instance.go(">");

        page = window.splide_instance.index;
        application_context.page = page;
        
        update_button_visibility(application_context);
        change_close_button_title(application_context);
    } else {

        for(let blob_request_error of blob_response.detail.ary_request_error){
            render_request_error(blob_request_error);
        }
        enable_next(application_context);
    }
}
